// extracted by mini-css-extract-plugin
export default {"remove":"removableTag_remove__WszPJEB3","removeIcon":"removableTag_removeIcon__W-k12ewQ"};